const SUPABASE_URL = 'https://supabase.xiomex.fund/rest/v1';
const WHITELABEL_USER_ID = '7588dcc7-9d69-45ee-b6f5-959ca54c28de';
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.ewogICJyb2xlIjogImFub24iLAogICJpc3MiOiAic3VwYWJhc2UiLAogICJpYXQiOiAxNzI4ODc4NDAwLAogICJleHAiOiAxODg2NjQ0ODAwCn0.0C56OOhuOREfXTNIdYPUWmegoQSWUkpb5yqa0-FmgpI';

export const useUserStore = defineStore('userStore', {
  state: () => {
    return {
      userId: localStorage.getItem('xiomex_userId') || '',
      // Users registered from the AI product (xiomex.com) have no access to Xiomex
      onlyAiUser: localStorage.getItem('xiomex_onlyAiUser') === 'true',
    };
  },
  getters: {
    getUserId: (state) => state.userId,
    hasUserId: (state) => !!state.userId,
    isOnlyAiUser: (state) => state.onlyAiUser,
    // Base URL of the AI web app (strategies, create-strategy, code-transformer)
    aiAppUrl: (state) => {
      if (state.userId === WHITELABEL_USER_ID) return 'https://xiomexai-whitelabel-app.vercel.app';
      return state.onlyAiUser ? 'https://ai.xiomex.com' : 'https://ai.xiomex.fund';
    },
  },
  actions: {
    saveUserId(userId: string) {
      this.userId = userId;
      localStorage.setItem('xiomex_userId', userId);
      this.fetchOnlyAiUser();
    },
    clearUserId() {
      this.userId = '';
      this.onlyAiUser = false;
      localStorage.removeItem('xiomex_userId');
      localStorage.removeItem('xiomex_onlyAiUser');
    },
    async fetchOnlyAiUser() {
      if (!this.userId) return;
      try {
        const response = await fetch(
          `${SUPABASE_URL}/profiles?user_id=eq.${this.userId}&select=only_ai_user`,
          { headers: { apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${SUPABASE_ANON_KEY}` } },
        );
        if (!response.ok) return;
        const data: { only_ai_user: boolean | null }[] = await response.json();
        this.onlyAiUser = Boolean(data?.[0]?.only_ai_user);
        localStorage.setItem('xiomex_onlyAiUser', String(this.onlyAiUser));
      } catch (error) {
        console.error('Error fetching only_ai_user:', error);
      }
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot));
}
